import { queries } from '../../core/config'
// import ScrollService from './NativeScroll'
import ScrollService from './VirtualScroll'

ScrollService.getScrollOffset = () => {
    if (window.matchMedia(queries.smallWideMax).matches) {
        const fixedHeader = document.querySelector('.FixedHeader')
        if (!fixedHeader) {
            return 100
        }
        return fixedHeader.offsetHeight + fixedHeader.offsetTop + 10
    } else {
        return 0
    }
}

export const disableScroll = () => ScrollService.disableScroll()
export const enableScroll = () => ScrollService.enableScroll()
export const getScroll = () => ScrollService.getScroll()
export const getScrollTop = () => ScrollService.getScrollTop()
export const scrollToElement = (element, options) => ScrollService.scrollToElement(element, options)
export const setScrollPosition = (x = null, y = null) => {
    const id = window.location.hash.replace('#', '')
    const anchor = id ? document.getElementById(id) : null

    if (id && anchor) {
        const animate = ScrollService.isVirtual ? false : true
        ScrollService.scrollToElement(anchor, { animate: animate, mode: 'auto' })
    } else if (x !== null && y !== null) {
        ScrollService.setPosition(x, y)
    } else {
        //default chovani prohlizece
    }
}

export default ScrollService
